import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-domain-names-screenshot-message-dialog',
  standalone: false,
  templateUrl: './domain-names-screenshot-message-dialog.component.html',
  styleUrls: ['./domain-names-screenshot-message-dialog.component.scss'],
})
export class DomainNamesScreenshotMessageDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DomainNamesScreenshotMessageDialogComponent>,
  ) {}

  onContinue(): void {
    this.dialogRef.close('CONTINUE');
  }
}
